import React, { useState } from 'react'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import { Row, Col } from 'react-bootstrap'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { optionsClass, optionssession } from '../../Helper'
import { preostudentsubjectApi } from '../../../utils/AdminDashApi/PreOStudentSubjectApi'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'

const PreOStudentSubjectComp = () => {
    const [mainpagesearch, setmainpagesearch] = useState("")

    const [sessionmod1err, setsessionmod1err] = useState("")
    const [sessionmod1label, setsessionmod1label] = useState("")
    const [drpsession, setdrpsession] = useState("")
    const [myclass, setclass] = useState("")
    const [student, setstudent] = useState("")
    const handlemainpagesearch = (e) => {
        setmainpagesearch(e.target.value)
    }
    const drpfuncsession = (myval, myid) => {
        setdrpsession(myval)
    }
    const drpfuncclass = (myval, myid) => {
        setclass(myval)
    }
    const drpfuncstudent = (myval, myid) => {
        setstudent(myval)
    }

    const [ischkmodal,setischkmodal] = useState(false)
    const [checkedItems, setCheckedItems] = useState(false);

  const toggleCheckbox = (index) => {
    const newCheckedItems = [...checkedItems];
    newCheckedItems[index] = !newCheckedItems[index];
    setCheckedItems(newCheckedItems);
  };
  
  
    return (
        <>
            <div className="d-flex">

                <SidebarOfAdash />
                <div className="contentpartwidthwrapper">
                    <HeaderofAdash head="Student Subject" />
                    <div className="contentofadmindash contentflexvalue">
                        <div className="w690 m-auto">
                            <Row>
                                <Col lg={4} className="pr7">
                                    <div className="basicinput">
                                        <p>Search Student ID</p>
                                        <div className="wrap">
                                            <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch} />
                                            <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="pr7 pl7">
                                    <div className="basicinput">
                                        <p>Session</p>
                                        <div className="inputgap modalinputgap">
                                            <div className="dropdownwrapper">
                                                <Dropdown2 err={sessionmod1err === "err" ? "err" : ""} func={drpfuncsession} myplaceholder="Select" fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                                            </div>
                                            <label>{sessionmod1label}</label>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="pl7">
                                    <div className="basicinputfield h35p">
                                        <p>Class</p>
                                        <div className="inputgap">
                                            <div className="dropdownwrapper h40">
                                                <Dropdown2 err={false} func={drpfuncclass} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                                            </div>

                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="pr7">
                                    <div className="basicinputfield h35p">
                                        <p>Student</p>
                                        <div className="inputgap">
                                            <div className="dropdownwrapper h40">
                                                <Dropdown2 err={false} func={drpfuncstudent} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                                            </div>

                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="pl7 pr7">
                                <div className="basicinputfield h40p">
                                        <p>Selected Subject Count</p>
                                        <div className="inputgap h40">
                                           <input type="text" value="7" disabled />

                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <div className="flexvaluetable classSectionEntrytable">
                            <table>
                            <thead>
                                <tr>
                                    {
                                    preostudentsubjectApi.heading.map((item,key)=>{
                                        return(
                                        <th key={key}> <div>{item.head}</div> </th>
                                        )
                                    })
                                    }
                                </tr>
                            </thead>
                            
                       
                          <tbody>
                        {
                            preostudentsubjectApi.data.map((item,key)=>{
                                return(
                                    <>
                                    
                                    <tr>
                                      <td>
                                      <input
                                      className='checkboxcss'
                                        type="checkbox"
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            border: checkedItems[key] ? '2px solid red' : '2px solid black',
                                            color: 'red!important',
                                        }}
                                        checked={checkedItems[key]}
                                        onChange={() => toggleCheckbox(key)}
                                        />
                                      </td>
                                      <td>{item.subjectID}</td>
                                      <td>{item.subjectname}</td>
                                      
                                    </tr>
                                  
                                    </>
                                  )
                            })
                            }
                        </tbody>                        
                      
                      </table>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default PreOStudentSubjectComp